"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Camera = void 0;
var React = require("react");
var Camera = function (_a) {
    var _b = _a.style, style = _b === void 0 ? {} : _b;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24.63 18", style: style },
        React.createElement("g", { id: "Layer_2", "data-name": "Layer 2" },
            React.createElement("g", { id: "Layer_2-2", "data-name": "Layer 2" },
                React.createElement("circle", { cx: "12.44", cy: "10.06", r: "4.38" }),
                React.createElement("path", { d: "M4.12,1h.13A1.12,1.12,0,0,1,5.38,2.12v0a0,0,0,0,1,0,0H3a0,0,0,0,1,0,0v0A1.12,1.12,0,0,1,4.12,1Z" }),
                React.createElement("path", { d: "M22.46,2.62h-4a1.69,1.69,0,0,1-1.7-1.45A1.17,1.17,0,0,0,15.58,0H8.92A1.17,1.17,0,0,0,7.75,1.17a1.69,1.69,0,0,1-1.7,1.45H2.16A2.17,2.17,0,0,0,0,4.79V15.84A2.16,2.16,0,0,0,2.16,18h20.3a2.17,2.17,0,0,0,2.17-2.16v-11A2.17,2.17,0,0,0,22.46,2.62Zm-10,12.69a5.25,5.25,0,1,1,5.25-5.25A5.25,5.25,0,0,1,12.44,15.31ZM19.38,6a.75.75,0,1,1,0-1.5.75.75,0,0,1,0,1.5Z" })))));
};
exports.Camera = Camera;
//# sourceMappingURL=Camera.js.map